import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import logo from '../../photos/logo.png';
import InstagramIcon from '@mui/icons-material/Instagram';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import './styles.scss';

const navLinks = [
  { to: '/', label: 'Логістика', exact: true },
  { to: '/accounting', label: 'Бухгалтерія' },
  { to: '/contacts', label: 'Контакти' },
  { to: '/routes', label: 'Маршрути' },
  { to: '/vacancies', label: 'Вакансії' },
  // { to: '/3d-demo', label: '3D Тест' },
];

const phoneContacts = [
  { label: 'Логіст', phone: '+380966341617' },
  { label: 'Бухгалтер', phone: '+380960968402' },
];

function AppAppBar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [phoneOpen, setPhoneOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      padding: scrolled ? '8px 0' : '16px 0',
      background: scrolled
        ? 'rgba(10, 10, 15, 0.85)'
        : 'transparent',
      backdropFilter: scrolled ? 'blur(20px) saturate(180%)' : 'none',
      WebkitBackdropFilter: scrolled ? 'blur(20px) saturate(180%)' : 'none',
      borderBottom: scrolled ? '1px solid rgba(255,255,255,0.06)' : 'none',
      transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
    }}>
      <div style={{
        maxWidth: 1200,
        margin: '0 auto',
        padding: '0 8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}>
        {/* Logo */}
        <Link to="/" style={{ display: 'flex', alignItems: 'center' }}>
          <img src={logo} alt="The Hot Logistics" style={{
            height: scrolled ? 38 : 46,
            transition: 'height 0.4s ease',
          }} className="nav-logo" />
        </Link>

        {/* Desktop Nav */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 32,
        }} className="desktop-nav">
          {navLinks.map(link => (
            <NavLink
              key={link.to}
              exact={link.exact}
              to={link.to}
              activeStyle={{ color: '#16b724' }}
              style={{
                color: 'rgba(255,255,255,0.8)',
                textDecoration: 'none',
                fontSize: 15,
                fontWeight: 500,
                letterSpacing: '0.03em',
                textTransform: 'uppercase',
                transition: 'color 0.3s ease',
                position: 'relative',
              }}
            >
              {link.label}
            </NavLink>
          ))}
        </div>

        {/* Right side */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {/* Phone dropdown */}
          <div style={{ position: 'relative' }}
            onMouseEnter={() => setPhoneOpen(true)}
            onMouseLeave={() => setPhoneOpen(false)}
          >
            <a href="tel:+380966341617" className="nav-icon-btn" style={{
              color: 'rgba(255,255,255,0.8)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 40,
              height: 40,
              borderRadius: '50%',
              border: '1px solid rgba(255,255,255,0.15)',
              transition: 'all 0.3s ease',
              textDecoration: 'none',
            }}
            onMouseOver={e => {
              e.currentTarget.style.borderColor = '#16b724';
              e.currentTarget.style.color = '#16b724';
              e.currentTarget.style.boxShadow = '0 0 20px rgba(22,183,36,0.3)';
            }}
            onMouseOut={e => {
              e.currentTarget.style.borderColor = 'rgba(255,255,255,0.15)';
              e.currentTarget.style.color = 'rgba(255,255,255,0.8)';
              e.currentTarget.style.boxShadow = 'none';
            }}
            >
              <LocalPhoneIcon style={{ fontSize: 20 }} />
            </a>
            {phoneOpen && (
              <div style={{
                position: 'absolute',
                top: '100%',
                right: 0,
                marginTop: 8,
                background: 'rgba(10, 10, 15, 0.95)',
                backdropFilter: 'blur(20px)',
                border: '1px solid rgba(255,255,255,0.1)',
                borderRadius: 12,
                padding: '8px 0',
                minWidth: 180,
                animation: 'fadeInUp 0.2s ease-out',
              }}>
                {phoneContacts.map(c => (
                  <a key={c.phone} href={`tel:${c.phone}`} style={{
                    display: 'block',
                    padding: '10px 20px',
                    color: 'rgba(255,255,255,0.8)',
                    textDecoration: 'none',
                    fontSize: 14,
                    transition: 'all 0.2s ease',
                  }}
                  onMouseOver={e => {
                    e.currentTarget.style.background = 'rgba(22,183,36,0.15)';
                    e.currentTarget.style.color = '#4dc247';
                  }}
                  onMouseOut={e => {
                    e.currentTarget.style.background = 'transparent';
                    e.currentTarget.style.color = 'rgba(255,255,255,0.8)';
                  }}
                  >
                    {c.label}
                  </a>
                ))}
              </div>
            )}
          </div>

          {/* Instagram - hidden on mobile, shown in mobile menu */}
          <a
            href="https://www.instagram.com/hot_logistics/?utm_medium=copy_link"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-icon-btn nav-instagram"
            style={{
              color: 'rgba(255,255,255,0.8)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 40,
              height: 40,
              borderRadius: '50%',
              border: '1px solid rgba(255,255,255,0.15)',
              transition: 'all 0.3s ease',
              textDecoration: 'none',
            }}
            onMouseOver={e => {
              e.currentTarget.style.borderColor = '#16b724';
              e.currentTarget.style.color = '#16b724';
              e.currentTarget.style.boxShadow = '0 0 20px rgba(22,183,36,0.3)';
            }}
            onMouseOut={e => {
              e.currentTarget.style.borderColor = 'rgba(255,255,255,0.15)';
              e.currentTarget.style.color = 'rgba(255,255,255,0.8)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <InstagramIcon style={{ fontSize: 20 }} />
          </a>

          {/* Mobile hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="mobile-menu-btn"
            style={{
              display: 'none',
              background: 'none',
              border: 'none',
              color: 'white',
              cursor: 'pointer',
              padding: 4,
            }}
          >
            {mobileOpen ? <CloseIcon /> : <MenuIcon />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          background: 'rgba(10, 10, 15, 0.98)',
          backdropFilter: 'blur(20px)',
          padding: '24px',
          borderTop: '1px solid rgba(255,255,255,0.06)',
        }} className="mobile-menu">
          {navLinks.map(link => (
            <NavLink
              key={link.to}
              exact={link.exact}
              to={link.to}
              activeStyle={{ color: '#16b724' }}
              onClick={() => setMobileOpen(false)}
              style={{
                display: 'block',
                color: 'rgba(255,255,255,0.8)',
                textDecoration: 'none',
                fontSize: 18,
                fontWeight: 500,
                padding: '14px 0',
                borderBottom: '1px solid rgba(255,255,255,0.06)',
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
              }}
            >
              {link.label}
            </NavLink>
          ))}
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .desktop-nav { display: none !important; }
          .mobile-menu-btn { display: flex !important; }
          .nav-logo { height: 34px !important; }
          .nav-icon-btn { width: 34px !important; height: 34px !important; }
          .nav-instagram { display: none !important; }
        }
        @media (min-width: 769px) {
          .nav-logo { height: unset; }
        }
      `}</style>
    </nav>
  );
}

export default AppAppBar;
